import React, { Component } from 'react';
import { connect } from 'react-redux'
import {
    Form, FormGroup, Label, Col, Row, Card, CardBody, Input, Button, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import { setPageView } from '../../../../components/GoogleAnalytics/index';
import MultiSelect from '../../../../components/ReusableComponents/MultiSelect';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Link } from "react-router-dom";
import { sectionDataListTransform, sectionDataTransform, crawlerSelectionTransform, allSectionIdList, validateProductFormData } from './helper';
import { getCounterpartyType, getreportCategory, getReportFrontCoverList } from '../../../../Analyst/Cases/Create/actions'
import { fetchSectionList } from '../../../Corporate/Create/action'
import CorporateModal from '../../../../components/UI/CorporateModal/index';
import Modal from '../../../../components/UI/Modal/Modal';
import {standardProductType,BUSINESS_CHECK_CREDIT,ROC_SEARCH_REPORT,DUE_DILIGENCE_REPORT,EWS,PORTFOLIO_SCRUB,COMPLIANCE,BUSINESS_CHECK_COMPETITOR,BUSINESS_PROFILE_REPORT,SITE_VISIT,SHIPPING_DATA,MCA_DOCUMENT_DOWNLOAD,BUSINESS_CHECK_SUPPLIER,BUSINESS_CHECK_INTERNATIONAL,TEV,ENHANCED_DUE_DILIGENCE,KYC,LEI_VALIDATION,LEI_VERIFICATION,PROJECT_FIXED_COST,AR_MANAGEMENT_FIXED,AR_MANAGEMENT_VARIABLE,DEBT_COLLECTIONS,SKIP_TRACE,LEGAL_SERVICES,MDM,DATA_PROJECTS, spcsOptions,CDM_CUSTOMER,CDM_SUPPLIER,CDM_INTERNATIONAL,FI_PROJECTS, B2B_PROJECTS,FI_KYC_SOLUTIONS,FI_LEI,B2B_AR_MANAGEMENT,B2B_DEBT_COLLECTIONS,PROJECTS_MDM,PROJECTS_OTHERS,SPCS, CDM_PROJECTS_EDD, CDM_PROJECTS_TEV,CDM_PROJECTS_MSME,MSME,PROJECT_VARIABLE_COST,LEI_COMMISSION,COMMISSION,COMMISSION_SP,RESOURCE_COST,ESG} from '../../Constant';
const crawlerData = [{ id: "DATABASE", name: "DATABASE" }, { id: "GST", name: "GST" }, { id: "EPF", name: "EPF" }, { id: "MCA", name: "MCA" }, { id: "LEGAL", name: "LEGAL" }, { id: "RATINGS", name: "RATINGS" }, { id: "SOCIALMEDIA", name: "SOCIALMEDIA" }]

class EditDefaultProduct extends Component {
    constructor(props) {
        super(props);

        this.state = {
            productData: {},
            AddsectionData: [],
            sectionDataList: [],
            sectionData: [],
            scoreCardData: {},
            showValidateModal: false,
            body: null,
            standardProductCategoryOptions:['CDM - Customer','CDM - Supplier','CDM - International','CDM - Projects - TEV','CDM - Projects - EDD','CDM - MSME','FI - KYC Solutions','FI - LEI','FI - Projects','B2B - AR Management','B2B - Debt Collections','B2B - Projects','Projects - MDM','Projects - Others','Commission','ESG'],
            standardProductSegmentOptions:["Credit Decisioning and Monitoring (CDM)","Fraud and ID Solutions (FI)","B2B Collections","Projects","Referral","ESG"],
        };
    }

    handleStandardProduct = (value) => {    
        if(value == BUSINESS_CHECK_CREDIT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_CREDIT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == ROC_SEARCH_REPORT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[ROC_SEARCH_REPORT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == DUE_DILIGENCE_REPORT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[DUE_DILIGENCE_REPORT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == EWS){
            this.setState({
                standardProductCategoryOptions:spcsOptions[EWS],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == COMPLIANCE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[COMPLIANCE],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == PORTFOLIO_SCRUB){
            this.setState({
                standardProductCategoryOptions:spcsOptions[PORTFOLIO_SCRUB],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == BUSINESS_CHECK_COMPETITOR){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_COMPETITOR],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == BUSINESS_PROFILE_REPORT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_PROFILE_REPORT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == SITE_VISIT){
            this.setState({
                standardProductCategoryOptions:spcsOptions[SITE_VISIT],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == SHIPPING_DATA){
            this.setState({
                standardProductCategoryOptions:spcsOptions[SHIPPING_DATA],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == MCA_DOCUMENT_DOWNLOAD){
            this.setState({
                standardProductCategoryOptions:spcsOptions[MCA_DOCUMENT_DOWNLOAD],
                standardProductSegmentOptions:spcsOptions[CDM_CUSTOMER]})
        }else if(value == BUSINESS_CHECK_SUPPLIER){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_SUPPLIER],
                standardProductSegmentOptions:spcsOptions[CDM_SUPPLIER]})
        }else if(value == BUSINESS_CHECK_INTERNATIONAL){
            this.setState({
                standardProductCategoryOptions:spcsOptions[BUSINESS_CHECK_INTERNATIONAL],
                standardProductSegmentOptions:spcsOptions[CDM_INTERNATIONAL]})
        }else if(value == TEV){
            this.setState({
                standardProductCategoryOptions:spcsOptions[TEV],
                standardProductSegmentOptions:spcsOptions[CDM_PROJECTS_TEV]})
        }else if(value == ENHANCED_DUE_DILIGENCE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[ENHANCED_DUE_DILIGENCE],
                standardProductSegmentOptions:spcsOptions[CDM_PROJECTS_EDD]})
        }else if(value == MSME){
            this.setState({
                standardProductCategoryOptions:spcsOptions[MSME],
                standardProductSegmentOptions:spcsOptions[CDM_PROJECTS_MSME]})
        }else if(value == KYC){
            this.setState({
                standardProductCategoryOptions:spcsOptions[KYC],
                standardProductSegmentOptions:spcsOptions[FI_KYC_SOLUTIONS]})
        }else if(value == LEI_VALIDATION){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEI_VALIDATION],
                standardProductSegmentOptions:spcsOptions[FI_LEI]})
        }else if(value == LEI_VERIFICATION){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEI_VERIFICATION],
                standardProductSegmentOptions:spcsOptions[FI_LEI]})
        }else if(value == PROJECT_FIXED_COST){
            this.setState({
                standardProductCategoryOptions:spcsOptions[PROJECT_FIXED_COST],
                standardProductSegmentOptions:spcsOptions[FI_PROJECTS]})
        }else if(value == AR_MANAGEMENT_FIXED){
            this.setState({
                standardProductCategoryOptions:spcsOptions[AR_MANAGEMENT_FIXED],
                standardProductSegmentOptions:spcsOptions[B2B_AR_MANAGEMENT]})
        }else if(value == AR_MANAGEMENT_VARIABLE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[AR_MANAGEMENT_VARIABLE],
                standardProductSegmentOptions:spcsOptions[B2B_AR_MANAGEMENT]})
        }else if(value == DEBT_COLLECTIONS){
            this.setState({
                standardProductCategoryOptions:spcsOptions[DEBT_COLLECTIONS],
                standardProductSegmentOptions:spcsOptions[B2B_DEBT_COLLECTIONS]})
        }else if(value == SKIP_TRACE){
            this.setState({
                standardProductCategoryOptions:spcsOptions[SKIP_TRACE],
                standardProductSegmentOptions:spcsOptions[B2B_PROJECTS]})
        }else if(value == LEGAL_SERVICES){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEGAL_SERVICES],
                standardProductSegmentOptions:spcsOptions[B2B_PROJECTS]})
        }else if(value == MDM){
            this.setState({
                standardProductCategoryOptions:spcsOptions[MDM],
                standardProductSegmentOptions:spcsOptions[PROJECTS_MDM]})
        }
        else if(value == DATA_PROJECTS){
            this.setState({
                standardProductCategoryOptions:spcsOptions[DATA_PROJECTS],
                standardProductSegmentOptions:spcsOptions[PROJECTS_OTHERS]})
        }
        else if(value == RESOURCE_COST){
            this.setState({
                standardProductCategoryOptions:spcsOptions[RESOURCE_COST],
                standardProductSegmentOptions:spcsOptions[PROJECTS_OTHERS]})
        }
        else if(value == PROJECT_VARIABLE_COST){
            this.setState({
                standardProductCategoryOptions:spcsOptions[PROJECT_VARIABLE_COST],
                standardProductSegmentOptions:spcsOptions[FI_PROJECTS]})
        }
        else if(value == LEI_COMMISSION){
            this.setState({
                standardProductCategoryOptions:spcsOptions[LEI_COMMISSION],
                standardProductSegmentOptions:spcsOptions[FI_LEI]})
        }else if(value == COMMISSION){
            this.setState({
                standardProductCategoryOptions:COMMISSION_SP,
                standardProductSegmentOptions:spcsOptions[COMMISSION]})
        }else if(value == ESG){
            this.setState({
                standardProductCategoryOptions:ESG,
                standardProductSegmentOptions:spcsOptions[ESG]})
        }
        }
    componentDidMount(props) {
        setPageView('/Admin/corporate/defaultProduct/edit', document.location.href)
        this.props.fetchCounterPartyType();
        this.props.fetchReportCategory();
        this.props.fetchReportFrontCoverList();
        this.props.fetchSectionList();
        if (this.props.location.state) {
            this.setState({
                productData: {
                  ...this.state.productData,
                  id: this.props.location.state.id,
                  name: this.props.location.state.productName,
                  counterpartyType: this.props.location.state.counterpartyType,
                  reportCategory: this.props.location.state.reportCategory,
                  reportFrontCover: this.props.location.state.reportFrontCover,
                  productGeography: this.props.location.state.productGeography,
                  productCategory: this.props.location.state.productCategory,
                  productTitle: this.props.location.state.productTitle,
                  description: this.props.location.state.description,
                  turnAroundTime: this.props.location.state.turnAroundTime,
                  price: this.props.location.state.price,
                  databaseProduct: this.props.location.state.databaseProduct,
                  productType: this.props.location.state.productType,
                  shareable: this.props.location.state.shareable,
                  scorecardOrder: this.props.location.state.scorecardOrder,
                  reportType: this.props.location.state.reportType,
                  crawlers: this.props.location.state.crawlers,
                  standardProduct :this.props.location.state.standardProduct,
                  standardProductCategory :this.props.location.state.standardProductCategory,
                  standardProductSegment : this.props.location.state.standardProductSegment,
                  enabled: true,
                }
              });
            this.handleSectionList(this.props.location.state.sections)
            this.setScorecardData(this.props.location.state.riskfactors, this.props.location.state.riskGrades);
        }else if(this.props.selectedDefaultProduct){
            this.setState({
                productData: {
                  ...this.state.productData,
                  id: this.props.selectedDefaultProduct.id,
                  name: this.props.selectedDefaultProduct.productName,
                  counterpartyType: this.props.selectedDefaultProduct.counterpartyType,
                  reportCategory: this.props.selectedDefaultProduct.reportCategory,
                  reportFrontCover: this.props.selectedDefaultProduct.reportFrontCover,
                  productGeography: this.props.selectedDefaultProduct.productGeography,
                  productCategory: this.props.selectedDefaultProduct.productCategory,
                  productTitle: this.props.selectedDefaultProduct.productTitle,
                  description: this.props.selectedDefaultProduct.description,
                  turnAroundTime: this.props.selectedDefaultProduct.turnAroundTime,
                  price: this.props.selectedDefaultProduct.price,
                  databaseProduct: this.props.selectedDefaultProduct.databaseProduct,
                  productType: this.props.selectedDefaultProduct.productType,
                  shareable: this.props.selectedDefaultProduct.shareable,
                  scorecardOrder: this.props.selectedDefaultProduct.scorecardOrder,
                  reportType: this.props.selectedDefaultProduct.reportType,
                  crawlers: this.props.selectedDefaultProduct.crawlers,
                  enabled: true,
                  standardProduct :this.props.selectedDefaultProduct.standardProduct,
                  standardProductCategory :this.props.selectedDefaultProduct.standardProductCategory,
                  standardProductSegment : this.props.selectedDefaultProduct.standardProductSegment,
                }
              });
            this.handleSectionList(this.props.selectedDefaultProduct.sections)
            this.setScorecardData(this.props.selectedDefaultProduct.riskfactors, this.props.selectedDefaultProduct.riskGrades);
        }
    }

    handleSectionList = (selectedSectionData) => {
        const tempSectionData = sectionDataListTransform(selectedSectionData);
        this.setState(prevState => ({
            sectionData: tempSectionData,
            productData: { ...prevState.productData, "sectionList": tempSectionData }
        }));
    }
    setScorecardData = (riskfactors, riskGrades) => {
        let financialRiskFactorList = [];
        let nonFinancialRiskFactorList = [];
        for (let i = 0; i < riskfactors.length; i++) {
            let riskfactor = {};
            riskfactor.id = riskfactors[i].riskFactorId;
            riskfactor.name = riskfactors[i].riskFactorName
            riskfactor.assignedWeight = riskfactors[i].assignedWeight
            riskfactor.enabled = true
            if (riskfactors[i] && riskfactors[i].displayNameType === "FINANCIAL") {
                financialRiskFactorList.push(riskfactor);
            }
            if (riskfactors[i] && riskfactors[i].displayNameType === "NON_FINANCIAL") {
                nonFinancialRiskFactorList.push(riskfactor);
            }
        }
        this.setState(prevState => ({
            scoreCardData: {
                ...prevState.scoreCardData,
                riskGrades: riskGrades,
                financialRiskFactorList: financialRiskFactorList,
                nonFinancialRiskFactorList: nonFinancialRiskFactorList
            }
        }));
    }


    handleMultiSelectForCrawler = (selectedOption) => {
        const tempData = crawlerSelectionTransform(selectedOption);
        this.setState(prevState => ({
            productData: { ...prevState.productData, crawlersData: tempData }
        }));
    }

    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value
        if(SPCS.includes(name) ){
           this.handleStandardProduct(value);
        }
        this.setState(prevState => ({
            productData: { ...prevState.productData, [name]: value }
        }));
    }
    handleCustomerSegment = (event) => {
        let name = event.target.name;
        let value = event.target.value
        this.setState(prevState => ({
            productData: { ...prevState.productData, ['customerSegment']: value },
        }));
        
        
            
    }
    handleChekbox = (event) => {
        const name = event.target.name;
        const chacked = event.target.checked
        this.setState(prevState => ({
            productData: { ...prevState.productData, [name]: chacked }
        }));
    }

    selectedEntityCallback = (selectedSectionData) => {
        const tempSectionData = sectionDataTransform(selectedSectionData);
        this.setState({
            AddsectionData: tempSectionData
        })
    }

    reorder = (sections, startIndex, endIndex) => {
        const result = Array.from(sections);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        return result;
    };

    onDragEnd = (result) => {
        // dropped outside the list
        if (!result.destination) {
            const tempArr = Array.from(this.state.sectionData);
            tempArr.splice(result.source.index, 1);
            this.setState(prevState => ({
                sectionData: tempArr,
                productData: { ...prevState.productData, "sectionList": tempArr }
            }));
            return;
        }
        const items = this.reorder(
            this.state.sectionData,
            result.source.index,
            result.destination.index
        );
        this.setState(prevState => ({
            sectionData: items,
            productData: { ...prevState.productData, "sectionList": items }
        }));
    }
    getListStyle = isDraggingOver => ({
        background: isDraggingOver ? "lightblue" : "#DEE9E3",
        padding: 8,
        width: 500,
        height: 700,
        overflowY: 'scroll'
    });


    getItemStyle = (isDragging, draggableStyle) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: 14,
        margin: 5,
        width: 460,
        border: "groove",
        // change background colour if dragging
        background: isDragging ? "lightgray" : "white",

        // styles we need to apply on draggables
        ...draggableStyle
    });
    handleToggle = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            AddsectionData: []
        }))
    }
    handleAdd = () => {
        this.handleToggle();
    }
    handleAddSections = () => {
        if (this.state.AddsectionData.length == 0) {
            return;
        }
    
        let sectionIdList = allSectionIdList(this.state.sectionData);
        let updatedSectionData = [...this.state.sectionData];
        
        for (let i = 0; i < this.state.AddsectionData.length; i++) {
            if (!sectionIdList.includes(this.state.AddsectionData[i].id)) {
                updatedSectionData.push(this.state.AddsectionData[i]);
            }
        }
    
        this.setState(prevState => ({
            sectionData: updatedSectionData,
            productData: {
                ...prevState.productData,
                sectionList: updatedSectionData
            }
        }), this.handleToggle);
    }    
    handleCancel = () => {
        this.handleToggle();
    }
    toggleValidationModal = () => {
        this.setState(prevState => ({
            showValidateModal: !prevState.showValidateModal,
            body: null
        }));
    }

    validateProductData = () => {
        let errorList = [];
        errorList = validateProductFormData(this.state.productData);
        if (errorList.length === 0) {
            this.setState(prevState => ({
                showValidateModal: !prevState.showValidateModal,
                body: <div>
                    <ModalBody>
                    <h5 className="text-Success "><i className="fa fa-check-circle"></i>Submited</h5>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.toggleValidationModal}>Ok</Button>
                    </ModalFooter>
                </div>
            }))
        }
        else {
            this.setState(prevState => ({
                showValidateModal: !prevState.showValidateModal,
                body: <div>
                    <ModalHeader>Warning</ModalHeader>
                    <ModalBody>
                        <p className="alert alert-warning"><i className="fa fa-exclamation-circle orange"></i>&nbsp;&nbsp; Please check entered data for the field {errorList}</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={this.toggleValidationModal}>Ok</Button>
                    </ModalFooter>
                </div>
            }))

        }
    }


    productTypehandleChekbox = (event) => {
        let name = event.target.name;
        const chacked = event.target.checked
        if (chacked) {
            this.setState(prevState => ({
                productData: { ...prevState.productData, [name]: "QUICK" }
            }));
        }
        else {
            this.setState(prevState => ({
                productData: { ...prevState.productData, [name]: null }
            }));
        }
    }



    render() {

        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="mb-0">
                        Product Setup
                    </h5>
                </div>
                <Card>
                    <CardBody className="py-0">
                        <Form onSubmit={(e) => this.handleSubmit(e)}>
                            <Row>
                                <Col sm="13" className="border-right py-3">
                                    <FormGroup className="w-75">
                                        {/* <Label>Select Counterparty Type</Label> */}
                                        <label>Counterparty Type&nbsp;<span className="text-danger">*</span></label>
                                        <select name="counterpartyType" value={this.state.productData.counterpartyType} onChange={this.handleChange} className="form-control dropdown-counterparty border">
                                            <option >Select</option>
                                            {
                                                this.props.counterPartyTypeDropdown.map(p => {
                                                    return (
                                                        <option key={p} value={p}>{p}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <label>Report Category&nbsp;<span className="text-danger">*</span></label>
                                        <select name="reportCategory" value={this.state.productData.reportCategory} onChange={this.handleChange} className="form-control dropdown-counterparty border">
                                           console.log(this.state.productData)
                                            <option >Select</option>
                                            {
                                                
                                                this.props.reportCategoryDropdown !== undefined ?
                                                this.props.reportCategoryDropdown.map(p => {
                                                    return (
                                                        <option key={p} value={p}>{p}</option>
                                                    )
                                                }):<option key="" value="">""</option>
                                            }
                                           </select>
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <label>Report Front Cover&nbsp;<span className="text-danger">*</span></label>
                                        <select name="reportFrontCover" value={this.state.productData.reportFrontCover} onChange={this.handleChange} className="form-control dropdown-counterparty border">
                                            <option >Select</option>
                                            {
                                                this.props.reportFrontCoverDropdown.map(p => {
                                                    return (
                                                        <option key={p} value={p}>{p}</option>
                                                    )
                                                })
                                            }
                                           </select>
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Label>Product Name</Label>
                                        <Input name="name"
                                            type="text"
                                            className="form-control"
                                            value={this.state.productData.name}
                                            onChange={this.handleChange}
                                            placeholder="Enter A Product Name" />
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Label>Product Title</Label>
                                        <Input name="productTitle"
                                            type="text"
                                            className="form-control"
                                            value={this.state.productData.productTitle}
                                            onChange={this.handleChange}
                                            placeholder="Enter A Product Title for Cover Page" />
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Label>Product Description</Label>
                                        <Input name="description"
                                            type="text"
                                            className="form-control"
                                            value={this.state.productData.description}
                                            onChange={this.handleChange}
                                            placeholder="Enter A Product Description" />
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Label>Turn around time (days)</Label>
                                        <Input name="turnAroundTime" type="text"
                                            className="form-control"
                                            value={this.state.productData.turnAroundTime}
                                            onChange={this.handleChange}
                                            placeholder="Enter number of working days" />
                                        {/* <Input type="text" placeholder="Enter number of working days" /> */}
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Label>Position of Scorecard in Sections</Label>
                                        <Input name="scorecardOrder" type="text"
                                            className="form-control"
                                            value={this.state.productData.scorecardOrder}
                                            onChange={this.handleChange}
                                            placeholder="Enter number of working days" />
                                        {/* <Input type="text" placeholder="Enter number of working days" /> */}
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Label>Price</Label>

                                        <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text p-2">₹</span>
                                            </div>
                                            <Input name="price" type="number"
                                                className="form-control px-2"
                                                value={this.state.productData.price}
                                                onChange={this.handleChange}
                                                placeholder="Enter Price" />
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div>
                                            <label>&nbsp;&nbsp;
                                                <Input name="productType"
                                                    type="checkbox"
                                                    value={this.state.productData.productType}
                                                    checked={this.state.productData.productType}
                                                    onChange={this.productTypehandleChekbox}
                                                />
                                                &nbsp;&nbsp; QUICk?
                                            </label>
                                        </div>
                                    </FormGroup>

                                    <FormGroup>
                                        <div>
                                            <label>&nbsp;&nbsp;
                                                <Input name="databaseProduct"
                                                    type="checkbox"
                                                    value={this.state.productData.databaseProduct}
                                                    checked={this.state.productData.databaseProduct}
                                                    onChange={this.handleChekbox}
                                                />
                                                &nbsp;&nbsp; Database Product?
                                            </label>
                                        </div>
                                    </FormGroup>

                                    <FormGroup>
                                        <div>
                                            <label>&nbsp;&nbsp;
                                                <Input name="shareable"
                                                    type="checkbox"
                                                    value={this.state.productData.shareable}
                                                    checked={this.state.productData.shareable}
                                                    onChange={this.handleChekbox}
                                                />
                                                &nbsp;&nbsp; Shareable?
                                            </label>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div >
                                            Report Type:
                                            <label className='ml-5 '>
                                                <Input name="reportType" type="radio" value={"Landscape"} checked={this.state.productData.reportType === "Landscape"} onChange={this.handleChange} />{' '}
                                                Landscape
                                            </label>

                                            <label className='ml-5 '>
                                                <Input name="reportType" type="radio" value={"Portrait"} checked={this.state.productData.reportType === "Portrait"} onChange={this.handleChange} />{' '}
                                                Portrait
                                            </label>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        <div>
                                            Product Category:
                                            <label className='ml-5 '>
                                                <Input name="productCategory" type="radio" value={"CORPORATE"} checked={this.state.productData.productCategory === "CORPORATE"} onChange={this.handleChange} />{' '}
                                                Corporate
                                            </label>
                                            <label className='ml-5 '>
                                                <Input name="productCategory" type="radio" value={"NON_CORPORATE"} checked={this.state.productData.productCategory === "NON_CORPORATE"} onChange={this.handleChange} />{' '}
                                                Non Corporate
                                            </label>
                                            <label className='ml-5 '>
                                                <Input name="productCategory" type="radio" value={"INTERNATIONAL"} checked={this.state.productData.productCategory === "INTERNATIONAL"} onChange={this.handleChange} />{' '}
                                                International
                                            </label>
                                            <label className='ml-5 '>
                                                <Input name="productCategory" type="radio" value={"NOT_APPLICABLE"} checked={this.state.productData.productCategory === "NOT_APPLICABLE"} onChange={this.handleChange} />{' '}
                                                Not Applicable
                                            </label>
                                        </div>
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <label>Standard Product&nbsp;<span className="text-danger">*</span></label>
                                        <select name="standardProduct" value={this.state.productData.standardProduct} component="select" className="form-control dropdown-counterparty border" onChange={this.handleChange}>
                                        <option value="">Select</option>
                                        {
                                            standardProductType.map(p => {
                                                    return (
                                                        <option key={p} value={p}>{p}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <label>Product Category&nbsp;<span className="text-danger">*</span></label>
                                        <select  name="standardProductCategory" value={this.state.productData.standardProductCategory} component="select" className="form-control dropdown-counterparty border" onChange={this.handleChange}>
                                            <option value="">Select</option>
                                            {
                                                this.state.standardProductCategoryOptions.map(p => {
                                                        return (
                                                            <option key={p} value={p}>{p}</option>
                                                        )
                                                    })
                                                }
                                        </select>
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <label>Product Segment&nbsp;<span className="text-danger">*</span></label>
                                        <select  name="standardProductSegment" value={this.state.productData.standardProductSegment} component="select" className="form-control dropdown-counterparty border" onChange={this.handleChange}>
                                            <option value="">Select</option>
                                            {
                                                this.state.standardProductSegmentOptions.map(p => {
                                                    return (
                                                        <option key={p} value={p}>{p}</option>
                                                    )
                                            })
                                            }
                                    </select>
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>Choose Crawlers for API</Label>
                                        <MultiSelect data={crawlerData} selected={this.handleMultiSelectForCrawler} selectedValue={this.state.productData.crawlersData} />
                                    </FormGroup>
                                    <FormGroup className="w-75">
                                        <Button  color="primary" onClick={this.validateProductData}>Submit</Button>
                                    </FormGroup>
                                </Col>
                                <Col sm="11" className="border-right py-3">
                                    <FormGroup>
                                        <Label className="header-blue d-block p-2 text-primary font-weight-bold">Report Sections <Button className="mx-2" size="sm" outline color="primary" title="Add" id="add" onClick={this.handleAdd}>
                                            <i className="icon-plus"></i>Add
                                        </Button>
                                        </Label>
                                        <DragDropContext onDragEnd={this.onDragEnd}>
                                            <Droppable droppableId="droppable">
                                                {(provided, snapshot) => (
                                                    <div className='' {...provided.DroppableProps} ref={provided.innerRef}
                                                        style={this.getListStyle(snapshot.isDraggingOver)} >
                                                        {
                                                            this.state.sectionData.map((item, index) => (
                                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                                    {(provided, snapshot) => (
                                                                        <div className="card" ref={provided.innerRef}
                                                                            {...provided.draggableProps}
                                                                            {...provided.dragHandleProps}
                                                                            style={this.getItemStyle(
                                                                                snapshot.isDragging,
                                                                                provided.draggableProps.style
                                                                            )}
                                                                        >
                                                                            {item.name}

                                                                        </div>
                                                                    )}
                                                                </Draggable>
                                                            ))
                                                        }
                                                    </div>
                                                )}
                                            </Droppable>
                                        </DragDropContext>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
                <Modal show={this.state.showValidateModal} modalClosed={this.close} >
                    {/* {/ <p>Show Modal Data</p > /} */}
                    {this.state.body}
                </Modal>
                <CorporateModal toShow={this.state.showModal} modalClosed={this.handleToggle}
                    body={<Form >
                        <Row>
                            <Col >
                                <FormGroup>
                                    <Label>Choose Report Sections</Label>
                                    <MultiSelect data={this.props.sectionDataList} selected={this.selectedEntityCallback} selectedValue={this.state.AddsectionData} />
                                </FormGroup>
                                <FormGroup>
                                    <Button className="btn btn-primary mt-3" onClick={this.handleAddSections} >Add</Button>
                                    <Button className="btn btn-danger mt-3 ml-3" onClick={this.handleCancel} >cancel</Button>
                                </FormGroup>
                                <FormGroup>

                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>}
                />
                <footer className="text-center">
                    <Link className="btn btn-primary mt-3" color="primary" to="/corporate/defaultProduct/edit/scorecard"
                        state={{productData: this.state.productData, scoreCardData: this.state.scoreCardData}}>Next
                        <i className="bg-blue fa fa-angle-double-right"></i></Link>
                </footer>

            </Col>
        );
    }
}


const mapStateToProps = (state, ownProps) => ({
    counterPartyTypeDropdown: state.createCase.dropdownData,
    reportCategoryDropdown: state.createCase.reportCategorytData,
    reportFrontCoverDropdown: state.createCase.reportFrontCoverList,
    sectionDataList: state.corporateOnBoardingCreate.productSectionList,
    selectedDefaultProduct: state.allDefaultProduct.selectedDefaultProduct
})

const mapDispatchToProps = (dispatch, props) => ({
    fetchCounterPartyType: () => dispatch(getCounterpartyType()),
    fetchReportCategory: () => dispatch(getreportCategory()),
    fetchReportFrontCoverList: () => dispatch(getReportFrontCoverList()),
    fetchSectionList: () => { dispatch(fetchSectionList()) },

});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditDefaultProduct);